import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeacherDiagnosticListFieldsFragment = { __typename?: 'Diagnostic', id: string, name: string, diagnosticTemplateId?: string | null, status?: Types.DiagnosticStatus | null, minDueDate?: any | null, maxDueDate?: any | null, diagnosticSettings: Array<{ __typename?: 'DiagnosticSettings', id: string, startDate?: any | null }> };

export type TeacherDiagnosticsListQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.DiagnosticSortInput>> | Types.InputMaybe<Types.DiagnosticSortInput>>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type TeacherDiagnosticsListQuery = { __typename?: 'RootQueryType', diagnostics?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null, results?: Array<{ __typename?: 'Diagnostic', id: string, name: string, diagnosticTemplateId?: string | null, status?: Types.DiagnosticStatus | null, minDueDate?: any | null, maxDueDate?: any | null, diagnosticSettings: Array<{ __typename?: 'DiagnosticSettings', id: string, startDate?: any | null }> }> | null } | null };

export type TeacherDiagnosticStatusCountsQueryVariables = Types.Exact<{
  openFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  closedFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
  scheduledFilter?: Types.InputMaybe<Types.DiagnosticFilterInput>;
}>;


export type TeacherDiagnosticStatusCountsQuery = { __typename?: 'RootQueryType', open?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null, closed?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null, scheduled?: { __typename?: 'KeysetPageOfDiagnostic', count?: number | null } | null };

export const TeacherDiagnosticListFieldsFragmentDoc = gql`
    fragment TeacherDiagnosticListFields on Diagnostic {
  id
  name
  diagnosticTemplateId
  status
  minDueDate
  maxDueDate
  diagnosticSettings {
    id
    startDate
  }
}
    `;
export const TeacherDiagnosticsListDocument = gql`
    query TeacherDiagnosticsList($filter: DiagnosticFilterInput, $sort: [DiagnosticSortInput], $first: Int) {
  diagnostics(filter: $filter, sort: $sort, first: $first) {
    count
    results {
      ...TeacherDiagnosticListFields
    }
  }
}
    ${TeacherDiagnosticListFieldsFragmentDoc}`;

/**
 * __useTeacherDiagnosticsListQuery__
 *
 * To run a query within a React component, call `useTeacherDiagnosticsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherDiagnosticsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherDiagnosticsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useTeacherDiagnosticsListQuery(baseOptions?: Apollo.QueryHookOptions<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>(TeacherDiagnosticsListDocument, options);
      }
export function useTeacherDiagnosticsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>(TeacherDiagnosticsListDocument, options);
        }
// @ts-ignore
export function useTeacherDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>;
export function useTeacherDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherDiagnosticsListQuery | undefined, TeacherDiagnosticsListQueryVariables>;
export function useTeacherDiagnosticsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>(TeacherDiagnosticsListDocument, options);
        }
export type TeacherDiagnosticsListQueryHookResult = ReturnType<typeof useTeacherDiagnosticsListQuery>;
export type TeacherDiagnosticsListLazyQueryHookResult = ReturnType<typeof useTeacherDiagnosticsListLazyQuery>;
export type TeacherDiagnosticsListSuspenseQueryHookResult = ReturnType<typeof useTeacherDiagnosticsListSuspenseQuery>;
export type TeacherDiagnosticsListQueryResult = Apollo.QueryResult<TeacherDiagnosticsListQuery, TeacherDiagnosticsListQueryVariables>;
export const TeacherDiagnosticStatusCountsDocument = gql`
    query TeacherDiagnosticStatusCounts($openFilter: DiagnosticFilterInput, $closedFilter: DiagnosticFilterInput, $scheduledFilter: DiagnosticFilterInput) {
  open: diagnostics(filter: $openFilter, first: 1) {
    count
  }
  closed: diagnostics(filter: $closedFilter, first: 1) {
    count
  }
  scheduled: diagnostics(filter: $scheduledFilter, first: 1) {
    count
  }
}
    `;

/**
 * __useTeacherDiagnosticStatusCountsQuery__
 *
 * To run a query within a React component, call `useTeacherDiagnosticStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherDiagnosticStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherDiagnosticStatusCountsQuery({
 *   variables: {
 *      openFilter: // value for 'openFilter'
 *      closedFilter: // value for 'closedFilter'
 *      scheduledFilter: // value for 'scheduledFilter'
 *   },
 * });
 */
export function useTeacherDiagnosticStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>(TeacherDiagnosticStatusCountsDocument, options);
      }
export function useTeacherDiagnosticStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>(TeacherDiagnosticStatusCountsDocument, options);
        }
// @ts-ignore
export function useTeacherDiagnosticStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>;
export function useTeacherDiagnosticStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherDiagnosticStatusCountsQuery | undefined, TeacherDiagnosticStatusCountsQueryVariables>;
export function useTeacherDiagnosticStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>(TeacherDiagnosticStatusCountsDocument, options);
        }
export type TeacherDiagnosticStatusCountsQueryHookResult = ReturnType<typeof useTeacherDiagnosticStatusCountsQuery>;
export type TeacherDiagnosticStatusCountsLazyQueryHookResult = ReturnType<typeof useTeacherDiagnosticStatusCountsLazyQuery>;
export type TeacherDiagnosticStatusCountsSuspenseQueryHookResult = ReturnType<typeof useTeacherDiagnosticStatusCountsSuspenseQuery>;
export type TeacherDiagnosticStatusCountsQueryResult = Apollo.QueryResult<TeacherDiagnosticStatusCountsQuery, TeacherDiagnosticStatusCountsQueryVariables>;